export default __webpack_public_path__ + "static/media/home-hero1.2b3c6766.jpg";